import { takeEvery, put, call } from 'redux-saga/effects';
import { Creators, Types } from 'src/store/redux/statistics-me/actions';
import statisticsAPI from 'src/services/api/statistics';
import { handleErrorResponse } from 'src/lib/helpers/errors';
import { DBErrorMonitor } from 'src/services/error-monitor';

export function* getDBPerformance(filters: any = null) {
  try {
    // @ts-ignore: Unreachable code error
    
    const response = yield call(statisticsAPI.meDBPerformance, filters);
    yield put(
      Creators.statisticsMeDbPerformanceRequestSuccess(response.data)
    );
  } catch (e) {
    let error = e;
    DBErrorMonitor.captureException(e, {
      saga: 'getDBPerformance',
      entity: 'statistics',
    });
    handleErrorResponse(error);
    yield put(Creators.statisticsMeDbPerformanceRequestError(error));
  }
}

export function* watchGetDBPerformance() {
  yield takeEvery(
    Types.STATISTICS_ME_DB_PERFORMANCE_REQUEST,
    getDBPerformance
  );
}

export default watchGetDBPerformance;
